import { Chip, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { UserTenantMembershipStatusProps } from 'common/services/api/TenantUserMembership/TenantUserMembershipApiTypeDefs';
import { EntitiesStatus } from 'common/types/Entities';
import { _getStatusChipColor } from 'common/utils/ColumnGenerator';
import { _calculateStatusTooltipMessage, getStatusDisplayName } from 'common/utils/statusHelpers';

export type UtmStatusBadgeProps = {
  statusTestId?: string;
  chipSize?: 'small' | 'medium';
  status?: string;
  tooltipProps: UserTenantMembershipStatusProps;
};

export const UtmStatusBadge = ({ statusTestId, status, tooltipProps, chipSize }: UtmStatusBadgeProps) => {
    const theme = useTheme();
    const chipColor = _getStatusChipColor(status, theme);
    const chipLabel = getStatusDisplayName(status as EntitiesStatus);
    const chipTooltip = _calculateStatusTooltipMessage(tooltipProps);
    return (
        <Tooltip title={chipTooltip}>
            <Chip
                data-testid={`${statusTestId ?? status}-utm-status-chip`}
                label={chipLabel}
                sx={{ backgroundColor: chipColor, pointerEvents: 'auto' }}
                size={chipSize}
                id='outlined'
            />
        </Tooltip>
    );
};
